import { useCallback } from 'react';
import { Stack, Anchor } from '@mantine/core';
import Text from '@ui/components/Text/Text';
import useCurrentUserOwnsWorkspace from 'src/new_arch/modules/workspaces/hooks/useCurrentUserOwnsWorkspace';
import useRequestSeatsMutation from '@projects/queries/useRequestSeatsMutation';
import Project from 'src/entities/project'
import { trackManagerSeatRequestedForOthers } from 'src/services/tracker/trackers/projects';

type ManagersEmailsErrorProps = {
	workspaceID: number;
	emails: string[];
	project: Project;
};

const ManagersEmailsError = ( { workspaceID, emails, project }: ManagersEmailsErrorProps ) => {
	const currentUserOwnsWorkspace = useCurrentUserOwnsWorkspace( { workspaceID } );
	const { mutate: requestSeatsFor } = useRequestSeatsMutation();

	const onRequestSeatsForClick = useCallback( () => {
		trackManagerSeatRequestedForOthers( { projectID: project.id } );
		requestSeatsFor( { emails, project } );
	}, [ requestSeatsFor, emails, project ] );

	return (
		<Stack spacing={4}>
			<Text color="red.4" variant="caption-regular">Only workspace members can be invited as managers</Text>
			<Text variant="caption-regular">
				To add them, {currentUserOwnsWorkspace ? (
					<Anchor color="blue.5" href={`/user/workspaces/${workspaceID}/members`}>go to workspace settings.</Anchor>
				) : (
					<Anchor
						color="blue.5"
						onClick={onRequestSeatsForClick}
					>
						send a request to workspace owner.
					</Anchor>
				)}
			</Text>
		</Stack>
	);
};

export default ManagersEmailsError;
